module.exports = __webpack_public_path__ + "static/logo-24fa607aed0662d8dc8db145b9eb6a22.jpg";